<template>
  <div>
     <div class="menu" id="menu"> 
      <div class="content1">
        <div class="btn">
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li>
               <router-link :to="{path:'/speciesblast',query:{url:url,blastPort:blastPort}}">Blast</router-link>
            </li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="content">
      <el-container>
        <el-header>Gene ID</el-header>
        <el-container>
          <!--侧边导航-->
          <el-aside width="250px">
            <el-menu text-color="black" active-text-color="seagreen">
              <el-menu-item v-model="index" @click="jumpIndexOne">
                <i class="el-icon-document"></i>
                <span>Basic information</span>
              </el-menu-item>
              <el-menu-item v-model="index" @click="jumpIndexTwo">
                <i class="el-icon-notebook-1"></i>
                <span>Reference sequences</span>
              </el-menu-item>
              <el-menu-item v-model="index" @click="jumpIndexThree">
                <i class="el-icon-setting"></i>
                <span>Gene structure</span>
              </el-menu-item>
              <el-menu-item v-model="index" @click="jumpIndexFour">
                <i class="el-icon-question"></i>
                <span>Gene annontation</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <!--导航内容-->
          <el-main>
            <div class="main">
              <div  v-if="this.index == '1'">
                <basicInformation v-if="this.index == '1'" :id="id"></basicInformation>
              </div>
              <div v-if="this.index == '2'">
                <referenceSequences v-if="this.index == '2'" :id="id"></referenceSequences>
              </div>

              <div v-if="this.index == '3'">
                <geneStructure v-if="this.index == '3'" :version="version" :id="id"></geneStructure>
              </div>
              <div v-if="this.index == '4'">
                <geneAnnontation v-if="this.index == '4'" :id="id"></geneAnnontation>
              </div>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import basicInformation from "@/components/page/Detail/Basic_information";
import geneAnnontation from "@/components/page/Detail/Gene_annontation";
import geneStructure from "@/components/page/Detail/Gene_structure";
import referenceSequences from "@/components/page/Detail/Reference_sequences";

export default {
  components: {
    basicInformation,
    geneAnnontation,
    geneStructure,
    referenceSequences,
  },
  data() {
    return {
      index: "1",
      id:"",
      version:"",
      blastPort:'',
      url:''
    };
  },
    created(){
      window.addEventListener("scroll", this.handleScroll); 
      let token=localStorage.getItem("authorization");
      if(token=="" || token==null){
         this.$alert("Login expired, please log in again", "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {
                 that.$router.push("/login");
              },
            });
        return false;
      }
       let url = this.$route.query.url;
    
    let blastPort = this.$route.query.blastPort;
    //console.log( this.$route.query.id);
    let id=this.$route.query.id;
    let version=this.$route.query.version;
    if(id=="" || id==null || version=="" || version==null){
      this.$router.go(-1);
    }else{
      this.id=id;
       this.url = url;
      this.blastPort = blastPort;
      this.version=version;
    }
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
    jumpIndexOne() {
      this.index = "1";
    },
    jumpIndexTwo() {
      this.index = "2";
    },
    jumpIndexThree() {
      this.index = "3";
    },
    jumpIndexFour() {
      this.index = "4";
    },
  },
};
</script>

<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.content {
  width: 1200px;
  margin: 10px auto;
  overflow: auto;
  background-color: #eee;
}
.el-header {
  background-color: #fff;
  color: seagreen;
  font-size: 22px;
  line-height: 44px;
}
.el-aside {
  background-color: #fff;
}
.el-main {
  min-height: 720px;
}
</style>>